import { useState } from 'react';
import styled, { css } from 'foundations-theming/utils';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RichContentBlock } from 'deal-plans-lib/components/RichContentBlock/RichContentBlock';
import { tableButtonStyles } from 'deal-plans-lib/components/milestone/styledComponents/tableButtonStyles';
import { usePortalTracking } from '../../hooks/usePortalTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditIconWrap = styled.span.withConfig({
  displayName: "DealPlanDescriptionHoverButton__EditIconWrap"
})(({
  theme
}) => css(["opacity:0;position:absolute;top:", ";right:", ";transition:opacity 150ms ease;"], theme.space['100'], theme.space['100']));
const DescriptionHoverButton = styled.button.withConfig({
  displayName: "DealPlanDescriptionHoverButton__DescriptionHoverButton"
})(["", ""], ({
  theme
}) => {
  return css(["position:relative;align-items:flex-start;background:transparent;border:none;display:flex;margin:-", " -", ";border-bottom:2px solid transparent;padding:", " ", ";padding-inline-end:", ";width:100%;text-align:left;", ":not(:disabled):hover ", ",:not(:disabled):focus-visible ", "{opacity:1;}"], theme.space['200'], theme.space['100'], theme.space['400'], theme.space['100'], theme.space['500'], tableButtonStyles, EditIconWrap, EditIconWrap);
});
export function DealPlanDescriptionHoverButton({
  description,
  onSave,
  dealId
}) {
  const [isEditing, setIsEditing] = useState(false);
  const {
    trackEditDescription,
    trackCancelDescription
  } = usePortalTracking(dealId);
  if (isEditing) {
    return /*#__PURE__*/_jsx(RichContentBlock, {
      description: description,
      onSave: html => {
        onSave(html).then(() => setIsEditing(false)).catch(() => {
          // error alert shown by useDealPlanActions; keep editor open for retry
        });
      },
      onCancel: () => {
        trackCancelDescription();
        setIsEditing(false);
      }
    });
  }
  if (description) {
    return /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsxs(DescriptionHoverButton, {
        "data-testid": "deal-plan-description-hover-button",
        onClick: () => {
          trackEditDescription();
          setIsEditing(true);
        },
        children: [/*#__PURE__*/_jsx(SanitizedText, {
          body: description
        }), /*#__PURE__*/_jsx(EditIconWrap, {
          children: /*#__PURE__*/_jsx(EditIcon, {
            color: "text-primary-disabled"
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "300",
    children: /*#__PURE__*/_jsx(Button, {
      use: "unstyled",
      onClick: () => {
        trackEditDescription();
        setIsEditing(true);
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(AddIcon, {
          color: "icon-core-disabled",
          size: "100"
        }), /*#__PURE__*/_jsx(Text, {
          use: "disabled",
          typography: "body-100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dealPlan.richContentBlock.addDescription"
          })
        })]
      })
    })
  });
}